import { fetchUtils, HttpError } from 'react-admin';
import { stringify } from 'query-string';
import pLimit from 'p-limit';
import { apiUrl } from './global';

export const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers();
  }
  const token = localStorage.getItem('token');
  options.headers.set('authorization', token);
  if (options.contentType)
    options.headers.set('Content-Type', options.contentType);

  return fetchUtils.fetchJson(url, options).then(response => {
    const { status, statusText } = response;
    
    if (status === 401) {
      throw new HttpError('登录已过期，请重新登录', 401, statusText);
    }
    if (status === 403) {
      throw new HttpError('没有权限访问', 403, statusText);
    }
    if (status === 404) {
      throw new HttpError('接口不存在', 404, statusText);
    }
    if (status >= 500) {
      throw new HttpError('服务器错误', status, statusText);
    }
    
    return response;
  });
};

export const uploadFile = file =>
  new Promise(async (resolve, reject) => {
    if (file == null) {
      resolve(file);
    }
    else if (file.rawFile instanceof File) {
      var formData = new FormData();
      formData.append("file", file.rawFile);
      httpClient(`${apiUrl}/File/UploadFile`, {
        method: 'POST',
        body: formData
      }).then(({ json }) => {
        if (json.Code === 1)
          resolve(json.Result.FilePath);
        reject(json.Message);
      })
    }
    else if (Object.prototype.toString.call(file) === '[object Object]') {
      file = await getUrlFromFiles(file)
        .then(res => res)
        .catch(e => { reject(e) });
      resolve(file);
    } else {
      resolve(file);
    }
  })
;

const getUrlFromFiles = data => {
  return new Promise(async (resolve, reject) => {
    for (let key of Object.keys(data)) {
      let isArray = data[key] instanceof Array;
      let dataArr = isArray ? data[key] : [data[key]];
      if (dataArr.length > 0) {
        const limit = pLimit(3);
        let results = await Promise.all(dataArr.map((d) => limit(() => uploadFile(d))))
          .then(res => res).catch(e => { reject(e); })
        data[key] = isArray ? results : results[0];
      }
    };
    resolve(data);
  })
};

export default {
  getList: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      ...{ _page: page - 1, _pagesize: perPage },
      ...{ _sort: field, _order: order },
      ...params.filter,
    };

    const url = `${apiUrl}/${resource}/GetList?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result.data, total: json.Result.total };
    });
  },

  getOne: (resource, params) => {
    return httpClient(`${apiUrl}/${resource}/GetOne/${params.id}`).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    });
  },

  getMany: (resource, params) => {
    const query = {
      ids: params.ids,
    };
    const url = `${apiUrl}/${resource}/GetMany?${stringify(query)}`;
    return httpClient(url).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    });
  },

  getManyReference: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      ...{ _page: page - 1, _pagesize: perPage },
      ...{ _sort: field, _order: order },
      ...{ [params.target]: params.id },
      ...params.filter,
    };

    const url = `${apiUrl}/${resource}/GetList?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result.data, total: json.Result.total };
    });
  },

  create: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      params.data = await getUrlFromFiles(params.data)
        .then(res => res)
        .catch(e => { reject(new HttpError(e, 406, '')) });

      httpClient(`${apiUrl}/${resource}/Create`, {
        method: 'POST',
        body: JSON.stringify(params.data),
      }).then(({ json }) => {
        if (json.Code == 0)
          reject(new HttpError(json.Message, 406, ''));
        resolve({ data: json.Result });
      })
    });
  },

  update: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      params.data = await getUrlFromFiles(params.data)
        .then(res => res)
        .catch(e => { reject(new HttpError(e, 406, '')) });

      httpClient(`${apiUrl}/${resource}/Update/${params.id}`, {
        method: 'PUT',
        body: JSON.stringify(params.data),
      }).then(({ json }) => {
        if (json.Code == 0)
          reject(new HttpError(json.Message, 406, ''));
        resolve({ data: json.Result });
      })
    });
  },

  updateMany: (resource, params) => {
    const query = {
      ids: params.ids,
    };
    return httpClient(
      `${apiUrl}/${resource}/UpdateMany/${params.data.payload}?${stringify(
        query
      )}`,
      {
        method: 'PUT',
        body: JSON.stringify(params.data.data),
      }
    ).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    });
  },

  delete: (resource, params) =>
    httpClient(`${apiUrl}/${resource}/Delete/${params.id}`, {
      method: 'DELETE',
    }).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    }),

  deleteMany: (resource, params) => {
    return httpClient(`${apiUrl}/${resource}/DeleteMany`, {
      method: 'DELETE',
      body: JSON.stringify({ ids: params.ids }),
    }).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    });
  },
};